import Modal from "./modal_controller"
import EventEmitter from "./../utils/EventEmitter"

export default class extends Modal {

    static targets = [
    ]

    initialize(){
        super.initialize()
    }

    beforeOpened({detail}) {
        EventEmitter.emit(`slider-index-changed-${this.data.get("name")}`, {index: parseInt(detail.index)} )
    }

    afterClosed() {}

}